<h1 mat-dialog-title>{{ 'protocolEdit.dialog.generateSign.title' | translate }}</h1>
<form>

  <div mat-dialog-content class="air-theme" style="overflow-y: hidden;">

    <div fxLayout="column">
      <div fxFlex>
        {{ 'protocolEdit.dialog.generateSign.signType.label' | translate }}:
        @for (item of signTypes; track item) {
          <div>
            <mat-checkbox (change)="onChangeSignTypeCheck($event)" [value]="item"
              [checked]="isSignTypeChecked(item)" [disabled]="disableSignType">
              {{ 'signType.' + item.translation | translate }}
            </mat-checkbox>
          </div>
        }
      </div>

      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'common.reportType.options.reviewBy.label' | translate }}</mat-label>
          <mat-select name="respDocs" [(ngModel)]="nextSign" (selectionChange)="onNextSignChange($event)">
            <mat-select-filter [displayMember]="'fullName'" [array]="respDocs"
              (filteredReturn)="respDocsFiltered =$event"
              [noResultsMessage]="'common.noResults' | translate"
            [placeholder]="'common.selectFilterPlaceholder' | translate"> </mat-select-filter>
            <mat-option>--</mat-option>
            @for (item of respDocsFiltered; track item) {
              <mat-option [value]="item.username">
                {{item.fullName}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

  </div>

  <br /><br />

  <div mat-dialog-actions class="air-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>{{ getOkLabel() }}</button>
    @if (!this.nextSign) {
      <div fxFlex="5px"></div>
    }
    <div fxFlex="5px"></div>
    @if (canRefuse) {
      <button mat-raised-button color="accent"
      (click)="refuseSign()">{{ 'button.refuse' | translate }}</button>
    }
    <div fxFlex="5px"></div>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>